import selectGamePath from './game-path';
import selectGameKeys from './select-game-keys';
import { selectTotalScoreNumber } from './best-score';

const selectGameSummary = (hotRisk, phrases) => {
  if (!hotRisk) return null;

  const { summary } = phrases;
  const totalScore = selectTotalScoreNumber(hotRisk.games, 'score');

  return [
    {
      key: 'games',
      value: `${hotRisk.timesPlayed}/2`,
      descriptor: summary.gamesPlayed,
    },
    {
      key: 'answers',
      value: `$${totalScore}`,
      units: phrases.scoreUnitsDollars,
      descriptor: summary.bestScore,
    },
  ];
};

const selectScoreCardHotRisk = ({ hotRisk }, phrases, remainingChallenges) => {
  const { hotRisk: { gameTitle, gameDescription, playNow } } = phrases;

  return {
    heroKey: 'hotRisk',
    gameTitle,
    gameDescription,
    imageUrl: 'https://images.ctfassets.net/gtqjh9j40j4m/7rUoXRsb8rlu3AOdqWf5xR/4fbe2b407b46bf9b27b8aa9e58bb31dc/hotrisk-icon-background.png',
    summary: selectGameSummary(hotRisk, phrases),
    nextGamePath: selectGamePath(remainingChallenges, 'hot_risk'),
    nextGameLink: playNow,
    ...selectGameKeys({ hotRisk }),
  };
};

export default selectScoreCardHotRisk;
